<template>
    <b-container fluid>
        <b-row v-if="step === 1">
            <b-col cols="12">
                <label for="">Tomese Una foto Personal</label>
                <app-web-cam
                    id="bodyguard-photo"
                    key="1"
                    size="small"
                    :multiple="false"
                    @input="takeBodyguardPhoto"
                    facing-mode="user"
                />
                <b-btn variant="confirm" @click="goToGunPhotos" block
                    >Continuar</b-btn
                >
            </b-col>
        </b-row>
        <b-row v-if="step === 2">
            <b-col>
                <label for="">Tomele fotos al arma asignada</label>
                <app-web-cam
                    id="gun-photos"
                    key="2"
                    size="small"
                    @input="takeGunPhotos"
                    facing-mode="environment"
                />
                <b-btn variant="confirm" @click="goToServiceForm" block
                    >Continuar</b-btn
                >
            </b-col>
        </b-row>
        <div v-if="step === 3">
            <b-row v-if="!edit">
                <b-button-group class="btn-block">
                    <b-col lg="6">
                        <b-button
                            class="btn-block"
                            variant="primary"
                            @click="selectType('vehicular')"
                        >
                            Vehícular
                        </b-button>
                    </b-col>
                    <b-col lg="6">
                        <b-button
                            class="btn-block"
                            variant="primary"
                            @click="selectType('personal')"
                        >
                            Personal
                        </b-button>
                    </b-col>
                </b-button-group>
            </b-row>
            <b-row v-if="!!component">
                <b-col cols="12">
                    <component
                        :is="component"
                        :bodyguard-photo="bodyGuardPhoto"
                        :gunPhotos="gunPhotos"
                        :latitude="latitude"
                        :longitude="longitude"
                    />
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>

<script>
import Autocomplete from "../../../../UI/Controls/AutocompleteV2/Autocomplete.vue";
import clientsRepository from "../../../../../repositories/clients.repository.js";
import bodyguardRepository from "../../../../../repositories/bodyguard.repository";
import { required } from "vuelidate/lib/validators";
import vehicularForm from "./BodyguardServiceFormVehicular";
import personalForm from "./BodyguardServiceFormPersonal";
import WebCam from "@components/UI/Controls/WebCam/WebCam";
export default {
    components: {
        appAutocomplete: Autocomplete,
        appVehicularForm: vehicularForm,
        appPersonalForm: personalForm,
        appWebCam: WebCam
    },
    props: {
        id: {
            required: true
        },
        myService: {
            type: Object,
            required: false
        },
        onSave: {
            type: Function
        },
        edit: {
            type: Boolean,
            default: () => false
        },
        longitude: {
            type: String,
            required: true
        },
        latitude: {
            type: String,
            required: true
        }
    },
    data: () => ({
        step: 1,
        component: "",
        type: "",
        bodyGuardPhoto: "",
        gunPhotos: []
    }),

    watch: {
        selectedClient(val) {
            if (!val) {
                this.selectedClient = "";
            } else {
                this.loadClientCustomers(val.id);
            }
        },
        edit(val) {
            this.updateForm(val);
        }
    },
    methods: {
        goToGunPhotos() {
            if (!this.bodyGuardPhoto)
                return toastr.error(
                    "Debe tomarse una foto para poder continuar"
                );

            this.step = 2;
            this.$bus.$emit("gun-photos.on");
        },
        goToServiceForm() {
            if (!this.bodyGuardPhoto || !this.gunPhotos.length)
                return toastr.error(
                    "Debe tomar las fotos para iniciar el servicio"
                );

            this.step = 3;
        },
        takeBodyguardPhoto(photo) {
            this.bodyGuardPhoto = photo;
        },
        takeGunPhotos(photos) {
            this.gunPhotos = photos;
        },
        updateForm(edit) {
            if (edit) {
                this.fillForm();
            } else {
                this.cleanFields();
            }
        },
        selectType(value) {
            this.type = value;
            const map = {
                vehicular: "appVehicularForm",
                personal: "appPersonalForm"
            };
            this.component = map[value];
        },
        saveService() {
            if (!this.type)
                return toastr.error(
                    "Debe diligenciar toda la información del servicio para iniciar"
                );

            const event = `bodyguard-service-${this.type}.save`;
            this.$bus.$emit(event);
        }
    },
    created() {
        this.$bus.$on("bodyguard-service.save", this.saveService);
    },
    beforeDestroy() {
        this.$bus.$off("bodyguard-service.save");
    },
    mounted() {}
};
</script>
<style scoped>
.plate {
    text-transform: uppercase;
}
</style>
